let lockDepth = 0;
let savedScrollY = 0;

export function getScrollbarWidth() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return 0;
  }

  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

export function lockBodyScroll() {
  if (typeof document === "undefined") {
    return 0;
  }

  const body = document.body;
  const root = document.documentElement;
  const width = getScrollbarWidth();

  if (lockDepth === 0) {
    savedScrollY = window.scrollY || root.scrollTop || 0;
    root.style.overflow = "hidden";
    root.style.overscrollBehavior = "none";
    body.style.overflow = "hidden";
    body.style.overscrollBehavior = "none";
    body.style.position = "fixed";
    body.style.top = `-${savedScrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    body.style.marginRight = "";
    body.style.paddingRight = width ? `${width}px` : "";
    root.style.setProperty("--modal-scrollbar-width", `${width}px`);
  }

  lockDepth += 1;
  return width;
}

export function unlockBodyScroll() {
  if (typeof document === "undefined" || lockDepth === 0) {
    return;
  }

  lockDepth -= 1;
  if (lockDepth > 0) {
    return;
  }

  const body = document.body;
  const root = document.documentElement;
  body.style.overflow = "";
  body.style.overscrollBehavior = "";
  body.style.position = "";
  body.style.top = "";
  body.style.left = "";
  body.style.right = "";
  body.style.width = "";
  body.style.marginRight = "";
  body.style.paddingRight = "";
  root.style.overflow = "";
  root.style.overscrollBehavior = "";
  root.style.removeProperty("--modal-scrollbar-width");
  try {
    window.scrollTo(0, savedScrollY);
  } catch {
    // jsdom does not implement scrollTo.
  }
}
